/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsDefendifyProfile } from './JumboStructsDefendifyProfile';
import {
    JumboStructsDefendifyProfileFromJSON,
    JumboStructsDefendifyProfileFromJSONTyped,
    JumboStructsDefendifyProfileToJSON,
} from './JumboStructsDefendifyProfile';

/**
 * 
 * @export
 * @interface JumboGetdefendifysettingsGetDefendifySettingsResult
 */
export interface JumboGetdefendifysettingsGetDefendifySettingsResult {
    /**
     * 
     * @type {Array<JumboStructsDefendifyProfile>}
     * @memberof JumboGetdefendifysettingsGetDefendifySettingsResult
     */
    profiles?: Array<JumboStructsDefendifyProfile>;
}

/**
 * Check if a given object implements the JumboGetdefendifysettingsGetDefendifySettingsResult interface.
 */
export function instanceOfJumboGetdefendifysettingsGetDefendifySettingsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetdefendifysettingsGetDefendifySettingsResultFromJSON(json: any): JumboGetdefendifysettingsGetDefendifySettingsResult {
    return JumboGetdefendifysettingsGetDefendifySettingsResultFromJSONTyped(json, false);
}

export function JumboGetdefendifysettingsGetDefendifySettingsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetdefendifysettingsGetDefendifySettingsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profiles': !exists(json, 'profiles') ? undefined : ((json['profiles'] as Array<any>).map(JumboStructsDefendifyProfileFromJSON)),
    };
}

export function JumboGetdefendifysettingsGetDefendifySettingsResultToJSON(value?: JumboGetdefendifysettingsGetDefendifySettingsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profiles': value.profiles === undefined ? undefined : ((value.profiles as Array<any>).map(JumboStructsDefendifyProfileToJSON)),
    };
}

